import { STEP } from '@/router/steps';
import type { StepConfig } from '@/router/types';
import { getRoute } from '@/router/utils/routeNames';
import { useStepValidators } from '@/router/utils/useStepValidators';

const {
  tariffsResultMatchesSearch,
  hasTariffSearchResult,
  isCompanyClientBlocked,
} = useStepValidators();

const stepConfig: StepConfig = {
  path: 'tarife/:berechnungsid?',
  routeName: 'offers',

  props: {
    icon: 'list',
    label: '2 Beitragsübersicht',

    isValid: () =>
      !isCompanyClientBlocked() &&
      (!tariffsResultMatchesSearch() || hasTariffSearchResult()),
  },

  // Die Sperre auf den Vorgaben greift nur am Button; Stepper, URL und Browser-Navigation
  // müssen die Berechnung für gesperrte Firmen-VN ebenfalls verhindern
  beforeEnter: (to, _from, next) => {
    if (isCompanyClientBlocked()) {
      // Query (z. B. _session) mitnehmen, sonst schickt der Modul-Guard erneut zum Login
      next({ name: getRoute(STEP.INPUT), query: to.query });
      return;
    }

    next();
  },
};

export default stepConfig;
